import * as React from 'react';
import withRoot from './withRoot';
import RoutesJSX from './Routes'

import { createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';
import CookiesBanner from './modules/views/CookieBanner';
function Index() {
  const routes = createRoutesFromElements(RoutesJSX);
  const router = createBrowserRouter(routes);
  return (
    <React.Fragment>
      <RouterProvider
        router={router}
      />
      <CookiesBanner/>
    </React.Fragment>
  );
}

export default withRoot(Index);